import React from 'react';
import { PickerOptionItem } from '../pages/types';

interface EntryLabelProp {
  label: string;
  value: any;
  visible?: boolean;
  optionItems?: PickerOptionItem[];
}
export default function EntryLabel({
  label,
  value,
  visible = true,
  optionItems = [],
}: EntryLabelProp) {

  const getOptionLabel = (value: any) => {
    if(!!optionItems && optionItems.length > 0) {
      const m = optionItems.find(item => item.value === value);

      if(!!m) return m.label;
    }
    return value;
  }

  return visible && (
    <div className="entry-field entry-label">
      <label>{label}</label>
      <div>
<pre>
{getOptionLabel(value)}
</pre>
      </div>
    </div>
  );
}